module.exports = __webpack_public_path__ + "img/v32.d1c6541e.jpg";